import React, { useState, useEffect } from "react";
import Axios from "axios";
import "./../../../../assets/css/purchase/form.css";

// React DateTime
import Datetime from "react-datetime";
import moment from "moment";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import ApModal from "../../../components/Modal/ApModal";
import FormAction from "../../../components/Actions/FormAction";
import ItemWhTable from "../../../components/Content/ItemWhTable";

// Model
import { whDocMasterModel } from "../../../../model/Warehouse/WHDocMasterModel";
import { whDocDetailModel } from "../../../../model/Warehouse/WHDocDetailModel";

import {
  getDataWithComp,
  getViewAp,
  formatCurrency,
  getAlert,
  getMaxWDPNo,
  randomDelay,
  parseCurrency,
  getDataWithJoin,
} from "../../../../utils/SamuiUtils";

import {
  formatDateTime,
  formatDateOnChange,
  formatStringDateToDate,
  formatThaiDateUiToDate,
} from "../../../../utils/DateUtils";

import { manageWhItemData } from "../../../../utils/WarehouseUtils";

const FormWDP = ({ callInitialize, mode, name, whDocNo }) => {
  const [formMasterList, setFormMasterList] = useState(whDocMasterModel());
  const [formDetailList, setFormDetailList] = useState([]);
  const [itemDataList, setItemDataList] = useState([]);
  console.debug();
  const [whDataList, setWhDataList] = useState([]);
  const [apDataList, setApDataList] = useState([]);

  // การเลือกคลังจากหน้าจอ
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    const whDataList = await getDataWithComp(
      "Tb_Set_WH",
      `AND  WH_Status = 'Y' ORDER BY WH_Name ASC`
    );
    if (whDataList && whDataList.length > 0) {
      setWhDataList(whDataList);
    }

    const apDataList = await getViewAp();
    if (apDataList && apDataList.length > 0) {
      setApDataList(apDataList);
    }

    if (window) {
      const WHID = localStorage.getItem("WHID");
      if (WHID) {
        handleChangeWarehouse(Number(WHID));
        // setSelectedWarehouse(Number(WHID));
      }
    }
  };

  const handleChangeMaster = (e) => {
    const { name, value } = e.target;
    // อัปเดตค่าใน formMasterList
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeDateMaster = (value, name) => {
    // ตรวจสอบว่า value เป็น moment object หรือไม่
    const newValue =
      value && value instanceof moment ? value.format("YYYY-MM-DD") : value;
    // อัปเดตค่าใน formMasterList
    setFormMasterList((prev) => ({
      ...prev,
      [name]: formatDateOnChange(newValue),
    }));
  };

  const handleChangeWarehouse = async (value) => {
    setFormDetailList([]);
    setItemDataList([]);

    const whId = parseCurrency(value);
    const companyId = localStorage.getItem("company");

    console.debug("🔍 Loading warehouse items:", { whId, companyId });

    try {
      const data = await getDataWithJoin(
        `
        v.Item_Id, v.Item_Barcode, v.Item_Code, 
        v.Item_Name, v.Item_Name_EN, v.Item_Short_Name, 
        v.Item_Unit_IN, v.Item_Unit_ST, v.Item_Unit_OUT, 
        v.Item_Cost, v.Item_Price, v.Item_PriceA, v.Item_PriceB, 
        v.Item_Brand, v.Item_Series, v.Item_Colour, v.Size_Line,
        ISNULL(wh.Item_Onhand, 0) AS Item_Onhand
      `,
        `View_Set_Item v`,
        `
        LEFT JOIN Tb_Set_ItmGroup grp ON (grp.Group_Id = v.Item_Group)
        ${
          whId
            ? `LEFT JOIN (
          SELECT wh.*, ROW_NUMBER() OVER (PARTITION BY wh.Item_Id ORDER BY wh.Item_Onhand DESC) AS rn
          FROM API_1101_WH_ITEM_ONHAND wh
          WHERE wh.WH_Id = ${whId}
        ) wh ON (wh.Item_Id = v.Item_Id AND wh.rn = 1)`
            : ""
        }
      `,
        `
        WHERE v.Comp_Id = ${companyId} 
        AND grp.Comp_Id = ${companyId}
        AND grp.Group_Code = 'G'
        AND ISNULL(v.is_Active, v.Item_Status) = 'Y'
        ORDER BY v.Item_Short_Name, v.Item_Brand, v.Item_Series, v.Item_Colour, v.Size_Line
      `
      );

      console.debug("✅ Data loaded:", data?.length, "items");
      console.debug("Sample item:", data?.[0]);

      if (data && data.length > 0) {
        setItemDataList(data);
      } else {
        console.warn("⚠️ No items found for warehouse:", whId);
      }
    } catch (error) {
      console.error("❌ Error loading warehouse items:", error);
      alert(`เกิดข้อผิดพลาด: ${error.message || error}`);
    }

    setSelectedWarehouse(value);
  };

  const handleQuantityChange = (index, type, value, onHand) => {
    // ตรวจสอบว่าค่าที่กรอกเข้ามาเป็นตัวเลขหรือตัวเลขที่มีจุดทศนิยม
    if (!/^\d*\.?\d*$/.test(value)) {
      //getAlert("FAILED", "กรุณากรอกเฉพาะตัวเลขเท่านั้น");
      return;
    }

    const updatedList = [...formDetailList];

    // หยอดข้อมูล เพิ่ม/ลด รายละเอียดสินค้า แยกตามประเภท
    if (type === "increase") {
      updatedList[index].itemIncrease = value;
      updatedList[index].itemDecrease = null;
      updatedList[index].itemBalance =
        parseCurrency(onHand) + parseCurrency(value);
      updatedList[index].itemQty = parseCurrency(value);
    } else if (type === "decrease") {
      // ดักไม่ให้ปรับปรุงเกินกว่าสินค้าคงเหลือ เฉพาะตอนปรับลดสินค้า
      if (value > onHand) {
        getAlert("FAILED", "กรุณาระบุจำนวนไม่เกินคงเหลือ");
        updatedList[index].itemIncrease = null;
        updatedList[index].itemDecrease = null;
        updatedList[index].docType = null;
        updatedList[index].itemBalance = parseCurrency(onHand);
        setFormDetailList(updatedList);
        return;
      }

      updatedList[index].itemIncrease = null;
      updatedList[index].itemDecrease = value;
      updatedList[index].itemQty = parseCurrency(value);
      updatedList[index].itemBalance =
        parseCurrency(onHand) - parseCurrency(value);
    }

    updatedList[index].docType = type === "increase" ? "AI" : "AO";
    setFormDetailList(updatedList);
  };

  const handleFocus = (index, field) => {
    const updatedList = [...formDetailList];
    updatedList[index][field] = parseCurrency(updatedList[index][field]) || 0;
    setFormDetailList(updatedList);
  };

  const handleBlur = (index, field, value) => {
    const numericValue = parseCurrency(value) || 0;
    const formattedValue = formatCurrency(numericValue);

    const updatedList = [...formDetailList];
    updatedList[index][field] = formattedValue;
    setFormDetailList(updatedList);
  };

  // SET AP
  const [showApModal, setShowApModal] = useState(false);
  const handleApShow = () => setShowApModal(true);
  const handleApClose = () => setShowApModal(false);
  const onRowSelectAp = (apSelected) => {
    try {
      setFormMasterList({
        ...formMasterList,
        whDocCustId: apSelected.AP_Id,
        whDocCustCode: apSelected.AP_Code,
        whDocCustName: apSelected.AP_Name,
      });
      handleApClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  // SET ITEM
  const [showItemModal, setShowItemModal] = useState(false);
  const handleItemShow = () => setShowItemModal(true);
  const handleItemClose = () => setShowItemModal(false);
  const onRowSelectItem = (itemsSelected) => {
    try {
      // ใช้ Set เพื่อกรอง Item_Id ที่ซ้ำกัน
      const uniqueItems = Array.from(
        new Set(itemsSelected.map((item) => item.Item_Id))
      ).map((id) => {
        return itemsSelected.find((item) => item.Item_Id === id);
      });

      // อัปเดตรายการโดยคงค่าของสินค้าที่เคยมีอยู่
      const updatedFormDetailList = uniqueItems.map((itemSelected) => {
        // ค้นหาว่ามีสินค้าอยู่ใน formDetailList เดิมหรือไม่
        const existingItem = formDetailList.find(
          (item) => item.itemId === itemSelected.Item_Id
        );

        return {
          line: existingItem?.line || null,
          itemId: itemSelected.Item_Id,
          itemCode: itemSelected.Item_Code,
          itemName: itemSelected.Item_Name,
          itemQty: formatCurrency(0),
          itemIncrease: formatCurrency(0),
          itemDecrease: formatCurrency(0),
          itemUnit: existingItem
            ? existingItem.itemUnit
            : itemSelected.Item_Unit_ST,
          itemOnHand: itemSelected.Item_Onhand || 0,
          itemBalance: itemSelected.Item_Onhand || 0,
          itemPriceUnit: 0,
          itemTotal: 0,
          docType: null,
          itemIsReturn: null,
          itemReturnDate: null,
          fWhId: itemSelected.F_WH_Id || null,
          fWhCode: itemSelected.F_WH_Code || null,
          fWhName: itemSelected.F_WH_Name || null,
          fZoneId: itemSelected.F_Zone_Id || null,
          fLtId: itemSelected.F_LT_Id || null,
          tWhId: itemSelected.T_WH_Id || null,
          tWhName: itemSelected.T_WH_Name || null,
          tZoneId: itemSelected.T_Zone_Id || null,
          tLtId: itemSelected.T_LT_Id || null,
          refDocId: itemSelected.Ref_DocID || null,
        };
      });

      setFormDetailList(updatedFormDetailList);
      handleItemClose();
    } catch (error) {
      getAlert("FAILED", error);
    }
  };
  const handleRemoveRow = (index) => {
    const newList = formDetailList.filter((_, i) => i !== index);
    setFormDetailList(newList);
  };

  const handleUploadAttachments = async (whDocId) => {
    const pendingFiles = selectedFiles.filter((file) => file.isPending);
    if (pendingFiles.length === 0) return;

    try {
      const filesWithBase64 = pendingFiles.map((file) => ({
        id: file.id,
        name: file.name,
        type: file.type,
        size: file.size,
        dataUrl: file.dataUrl,
        isPending: true,
        displayName: file.name,
      }));

      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/upload-file`,
        {
          comp_id: localStorage.getItem("company"),
          doc_id: whDocId,
          DocCode_ID: 18, // รหัสประเภทเอกสาร ปรับตามระบบ
          upload_by: localStorage.getItem("name") || "system",
          file_status: "Y",
          files: filesWithBase64,
          doc_no_ref: null,
        },
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      if (response.data.status === "OK") {
        setSelectedFiles((prev) =>
          prev
            .filter((file) => !file.isPending)
            .concat(
              response.data.files.map((file) => ({
                F_Id: file.File_Id,
                fileName: file.fileName,
                File_Url: file.fileUrl,
                uploadDate: file.uploadDate,
                uploadBy: file.uploadBy,
              }))
            )
        );
        // getAlert("OK", "อัปโหลดไฟล์สำเร็จ");
      } else {
        throw new Error(response.data.message || "การอัปโหลดล้มเหลว");
      }
    } catch (error) {
      console.error("UPLOAD ERROR:", error);
      getAlert("FAILED", `การอัปโหลดไฟล์ล้มเหลว: ${error.message}`);
    }
  };

  const handleSubmit = async () => {
    try {
      if (!selectedFiles || selectedFiles.length === 0) {
        getAlert("FAILED", "กรุณาแนบไฟล์ก่อนทำการบันทึก");
        return;
      }
      // ทดสอบหน่วงเวลาก่อนบันทึก (ทดสอบป้องกันการซ้ำของ Doc_No)
      await randomDelay();

      const findMaxWDPNo = await getDataWithComp(
        "WHDoc_H",
        `AND WHDoc_Type = '3' ORDER BY WHDoc_No DESC`
      );
      const maxWDP = getMaxWDPNo(findMaxWDPNo, "WDP");
      let newMaxWDP = maxWDP;
      // ตรวจสอบค่า formMasterList.apID และ formMasterList.apCode

      if (selectedWarehouse === null) {
        getAlert("FAILED", "กรุณาเลือกจากคลัง");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า apID หรือ apCode
      }

      // ตรวจสอบค่า formMasterList.apID และ formMasterList.apCode
      // if (!formMasterList.whDocCustId) {
      //     getAlert("FAILED", "กรุณาเลือกผู้ขาย");
      //     return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า apID หรือ apCode
      // }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้าที่จะปรับปรุง");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบค่าภายใน formDetailList
      for (const item of formDetailList) {
        if (!item.itemQty || parseCurrency(item.itemQty) === 0) {
          getAlert(
            "FAILED",
            `กรุณากรอกจำนวนปรับปรุงของสินค้า ${item.itemName}`
          );
          return; // หยุดการทำงานหากจำนวนของสินค้าเป็น 0 หรือไม่มีค่า
        }
      }

      // // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        wh_doc_no: newMaxWDP,
        wh_doc_type: 3,
        wh_doc_cust_id: parseCurrency(formMasterList.whDocCustId, 10),
        wh_doc_date: formatStringDateToDate(formMasterList.whDocDate),
        wh_doc_trans_date: formatStringDateToDate(
          formMasterList.whDocTransDate
        ),
        wh_doc_created_date: formatThaiDateUiToDate(
          formMasterList.whDocCreatedDate
        ),
        wh_doc_created_by: formMasterList.whDocCreatedBy,
        wh_doc_status: parseCurrency("1", 10),
        wh_doc_seq: formatDateTime(new Date()),
        wh_doc_remark: formMasterList.whDocRemark,
        wh_doc_comp_id: formMasterList.whDocCompId,
        wh_doc_show_front: null,
        ref_doc_id: formMasterList.refDocId,
        f_wh_id: selectedWarehouse || null,
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/create-wh-doc-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      if (response.data.status === "OK") {
        const getWhDocIdResponse = await Axios.post(
          `${process.env.REACT_APP_API_URL}/api/get-by-wh-doc-no`,
          {
            table: "WHDoc_H",
            wh_doc_no: formMasterData.wh_doc_no,
            comp_id: window.localStorage.getItem("company"),
          },
          {
            headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
          }
        );

        if (getWhDocIdResponse && getWhDocIdResponse.data.length > 0) {
          const whDocId = parseCurrency(
            getWhDocIdResponse.data[0].WHDoc_Id,
            10
          );

          const detailPromises = formDetailList.map(async (item, index) => {
            const formDetailData = {
              wh_doc_id: whDocId,
              line: index + 1,
              item_id: item.itemId,
              item_code: item.itemCode,
              item_name: item.itemName,
              item_qty: parseCurrency(item.itemQty),
              item_unit: item.itemUnit,
              item_price_unit: parseCurrency(item.itemPriceUnit),
              item_total: parseCurrency(item.itemTotal),
              doc_type: item.docType,
              f_wh_id: selectedWarehouse,
              f_zone_id: item.fZoneId,
              f_lt_id: item.fLtId,
              t_wh_id: item.tWhId,
              t_zone_id: item.fZoneId,
              t_lt_id: item.fLtId,
              ref_doc_id: item.refDocId,
              item_is_return: item.itemIsReturn,
              item_return_date: item.itemReturnDate,
            };

            await manageWhItemData(
              item.itemId, // Item ไอดีของสิ่งนั้นๆ
              item.itemCode, // Item โค้ดของสิ่งนั้นๆ
              item.itemName, // ชื่อ Item นั้นๆ
              selectedWarehouse, // WarehouseID ของไอเทม
              item.docType, // ประเภท เช่น IN/OUT/AI/AO/TI/TO
              parseCurrency(item.itemQty), // ค่าจำนวนที่กรอกจากหน้าจอ
              whDocId, // ไอดีเอกสาร
              newMaxWDP, // เลขเอกสาร
              newMaxWDP, // เลขเอกสารอ้างอิง
              formMasterList.whDocRemark // หมายเหตุ
            );

            return Axios.post(
              `${process.env.REACT_APP_API_URL}/api/create-wh-doc-d`,
              formDetailData,
              {
                headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
              }
            );
          });

          await Promise.all(detailPromises);
          await handleUploadAttachments(whDocId);
        }

        callInitialize();
        getAlert(response.data.status, "สร้างใบเบิกสินค้าสำเร็จ");
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleUpdate = async () => {
    console.debug("Begin handleUpdate");
  };

  const handleCancel = async () => {
    try {
      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        wh_doc_no: formMasterList.whDocNo,
        wh_doc_status: parseCurrency("13", 10),
        comp_id: window.localStorage.getItem("company"),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/cancel-wh-doc-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      callInitialize();
      getAlert(response.data.status, response.data.message);
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  return (
    <>
      <Breadcrumbs
        page={whDocNo}
        items={[
          { name: "คลังสินค้า", url: "/Warehouse" },
          { name: "จัดการเอกสารงานคลัง", url: "/treasury-documents" },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
      />
      <div
        className="body hidden-scrollbar"
        style={{ maxHeight: "80vh", overflowY: "auto" }}
      >
        <div class="container-fluid my-4">
          <div className="row mb-1">
            <div className="col-4">
              <div className="d-flex">
                <label>วันที่เอกสาร : </label>
                <Datetime
                  className="input-spacing-input-date"
                  name="whDocDate"
                  value={formMasterList.whDocDate || null}
                  onChange={(date) => handleChangeDateMaster(date, "whDocDate")}
                  dateFormat="DD-MM-YYYY"
                  timeFormat={false}
                  inputProps={{ readOnly: true, disabled: mode === "U" }}
                />
              </div>
            </div>
            <div className="col-4">
              <div className="d-flex">
                <label>ผู้ขาย</label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control input-spacing"
                    name="whDocCustId"
                    value={
                      (formMasterList.whDocCustCode || "") +
                      " " +
                      (formMasterList.whDocCustName || "")
                    }
                    onChange={handleChangeMaster}
                    disabled={true}
                  />
                  <button
                    className="btn btn-outline-secondary"
                    onClick={handleApShow}
                  >
                    <i className="fas fa-search"></i>
                  </button>
                  <ApModal
                    showApModal={showApModal}
                    handleApClose={handleApClose}
                    apDataList={apDataList}
                    onRowSelectAp={onRowSelectAp}
                  />
                </div>
              </div>
            </div>
            <div className="col-4">
              <div className="d-flex">
                <label className="">วันที่สร้าง : </label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  value={formMasterList.whDocCreatedDate}
                  disabled={true}
                />
              </div>
            </div>
          </div>
          <div className="row mb-1">
            <div className="col-4">
              <div className="d-flex">
                <label>วันที่จัดส่ง : </label>
                <Datetime
                  className="input-spacing-input-date"
                  name="whDocTransDate"
                  value={formMasterList.whDocTransDate || null}
                  onChange={(date) =>
                    handleChangeDateMaster(date, "whDocTransDate")
                  }
                  dateFormat="DD-MM-YYYY"
                  timeFormat={false}
                  inputProps={{ readOnly: true, disabled: false }}
                />
              </div>
            </div>
            <div className="col-4">
              <div className="d-flex">
                <label>สร้างโดย : </label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  value={formMasterList.whDocCreatedBy}
                  disabled={true}
                />
              </div>
            </div>
            <div className="col-4" />
          </div>
          <div className="row mb-1">
            <div className="col-4">
              <div className="d-flex">
                <label>จากคลัง : </label>
                <select
                  class="form-select"
                  value={selectedWarehouse}
                  onChange={(e) => handleChangeWarehouse(e.target.value)}
                >
                  <option value={null}>กรุณาระบุคลัง</option>
                  {whDataList.map((warehouse) => (
                    <option key={warehouse.WH_Id} value={warehouse.WH_Id}>
                      {warehouse.WH_Name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-4">
              <div className="d-flex">
                <label>หมายเหตุ : </label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="whDocRemark"
                  value={formMasterList.whDocRemark || ""}
                  onChange={handleChangeMaster}
                  disabled={false}
                />
              </div>
            </div>
            <div className="col-4" />
          </div>
          <hr />
        </div>
        <div className="container-fluid my-3">
          <div className="row">
            <div className="col-12">
              <ItemWhTable
                mode={mode}
                showItemModal={showItemModal}
                handleItemClose={handleItemClose}
                itemDataList={itemDataList}
                onRowSelectItem={onRowSelectItem}
                formDetailList={formDetailList}
                handleItemShow={handleItemShow}
                handleQuantityChange={handleQuantityChange}
                handleFocus={handleFocus}
                handleBlur={handleBlur}
                handleRemoveRow={handleRemoveRow}
                formatCurrency={formatCurrency}
                disabled={selectedWarehouse === null}
                selectedFiles={selectedFiles}
                setSelectedFiles={setSelectedFiles}
              />
            </div>
          </div>
        </div>
      </div>
      <FormAction
        onSubmit={handleSubmit}
        onUpdate={handleUpdate}
        onCancel={handleCancel}
        mode={mode}
        disabled={false}
        footer={true}
      />
    </>
  );
};

export default FormWDP;
